/**
 *
 *
 * @author yangxin
 * @date  2020-06-11
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from 'src/pages/home/store'
import { getFilingsAppearYears } from 'src/pages/home/apis/filingsAppearYears'

interface FilingsAppearYearsState {
  loading: boolean
  error: string
  appearYears: string[]
}

const initialState: FilingsAppearYearsState = {
  loading: false,
  error: '',
  appearYears: [],
}

const filingsAppearYearsSlice = createSlice({
  name: 'filingsAppearYearsSlice',
  initialState,
  reducers: {
    getDataStart(state): void {
      state.loading = true
    },
    getDataSuccess(state, action: PayloadAction<string[]>): void {
      state.loading = false
      state.appearYears = action.payload
    },
    getDataError(state, action: PayloadAction<string>): void {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const {
  getDataStart,
  getDataSuccess,
  getDataError,
} = filingsAppearYearsSlice.actions

export default filingsAppearYearsSlice.reducer

export const fetchAppearYears = (): AppThunk => async (
  dispatch,
): Promise<void> => {
  try {
    dispatch(getDataStart())
    const appearYears = await getFilingsAppearYears()
    dispatch(getDataSuccess(appearYears))
  } catch (err) {
    dispatch(getDataError(err as string))
  }
}
